import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        crops: false
      },
      options: {
        crops: []
      },
      selected: {
        crop: ''
      },
      editable: {
        crop: ''
      }
    }
  },

  methods: {

    async getCrops (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.crop
      const fetching = context.fetching?.crops
      const options = context.options?.crops

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.crops = true
      context.selected.crop = ''

      const filters = {
        filter_text: search
      }

      return await SSharedList.getCrops(filters).then(
        ({ data }) => {
          context.options.crops = data
        }
      ).catch(() => {
        context.options.crops = []
      }).finally(() => {
        context.fetching.crops = false
      })
    },

    async searchCrops (search, loading) {
      this.searchCropsProvider(this, search, loading)
    },

    searchCropsProvider: QUERY.debounce(
      ({ options }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.crops, {
          keys: ['crop_name', 'name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search
          }

          SSharedList.getCrops(filters).then(
            ({ data }) => {
              options.crops = data
            }
          ).catch(() => {
            options.crops = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
